module.exports = "../study/imgs/maps/Nagano/GWQ8/Climate/HourlyPrecipitation30/Nagano_HourlyPrecipitation30_MRI_RCP85_End.png";